import React from 'react';
import './issues.css';
import { IconButton } from '../../../components/icon-button';
import { Paragraph } from '../../../components/paragraph';

const IssueChoice = props => {
    const { activeIssue, setActiveIssue } = props;

    return (
        <div className="issues">
            <div className="issues__issue">
                <IconButton
                    iconName="local"
                    onClick={() => setActiveIssue('local')}
                    isActive={activeIssue === 'local'}
                    withSpacing={true}
                />
                <Paragraph colorScheme="dark" withSpacing={false}>
                    Local
                </Paragraph>
            </div>
            <div className="issues__issue">
                <IconButton
                    iconName="financial"
                    onClick={() => setActiveIssue('financial')}
                    isActive={activeIssue === 'financial'}
                    withSpacing={true}
                />
                <Paragraph colorScheme="dark" withSpacing={false}>
                    Financial
                </Paragraph>
            </div>
            <div className="issues__issue">
                <IconButton
                    iconName="global"
                    onClick={() => setActiveIssue('global')}
                    isActive={activeIssue === 'global'}
                    withSpacing={true}
                />
                <Paragraph colorScheme="dark" withSpacing={false}>
                    Global
                </Paragraph>
            </div>
        </div>
    );
};

export { IssueChoice };
